import gql from 'graphql-tag'

import { DeclarationFragment } from './DeclarationFragment'

export const UserFragment = gql`
  fragment UserFragment on User {
    id
    token
    firstName
    lastName
    email
    civility
    cgu_accepted_at
    institution {
      name
      id
    }
    declaration {
      ...DeclarationFragment
    }
  }
  ${DeclarationFragment}
`
